import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FooterComponent, HeaderComponent, SidebarMenuComponent } from '@core/components';
import { LayoutComponent } from '@core/layouts';
import { MaterialModule } from '@core/material';
import {
  CustomPaginatorDirective,
  NoWhitespaceDirective,
  LatinOnlyDirective
} from '@core/directives';
import { SameDateDisplayPipe } from './pipes/same-date-display.pipe';
import { OverlayModule } from '@angular/cdk/overlay';
import { TargetBlankDirective } from './directives/target-blank.directive';

const COMPONENTS = [
  HeaderComponent,
  FooterComponent,
  SidebarMenuComponent,
  LayoutComponent,
];

const DIRECTIVES = [
  CustomPaginatorDirective,
  NoWhitespaceDirective,
  LatinOnlyDirective,
  TargetBlankDirective
];
const PIPES = [
  SameDateDisplayPipe
];

@NgModule({
  imports: [CommonModule, RouterModule, MaterialModule, TranslateModule, OverlayModule],
  exports: [CommonModule, MaterialModule, TranslateModule, OverlayModule, ...DIRECTIVES, ...PIPES, ...COMPONENTS],
  declarations: [...COMPONENTS, ...DIRECTIVES, ...PIPES],
})
export class CoreModule { }
